import createAsyncActionType from '../../../utilities/createAsyncActionType';

export const GET_EMAIL_NOTIFICATIONS = createAsyncActionType('GET_EMAIL_NOTIFICATIONS');


export const UPDATE_EMAIL_NOTIFICATIONS = createAsyncActionType('UPDATE_EMAIL_NOTIFICATIONS');




// WEBPACK FOOTER //
// ./src/features/organization/types/getEmailNotifications.js